/**
 *
 *
 *
 *
 *
 */
import { o_util } from "../common/namespaces";
import type { GlobalUtils } from "../exports";

/**
 *
 *
 */
export type AttributeParserSync = GlobalUtils["attributeParser"];

/**
 *
 *
 */
export const attributeParserSync: AttributeParserSync = o_util.attributeParser;
